export function deepEqual<T>(a: T, b: T): boolean {
  if (a === b) {
    return true;
  }

  if (
    typeof a !== 'object' ||
        typeof b !== 'object' ||
        a === null ||
        b === null
  ) {
    return false;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) {
      return false;
    }

    const usedIndices = new Set<number>();
    return a.every((itemA) => {
      const matchIndex = b.findIndex(
        (itemB, index) =>
          !usedIndices.has(index) && deepEqual(itemA, itemB),
      );
      if (matchIndex === -1) {
        return false;
      }
      usedIndices.add(matchIndex);
      return true;
    });
  }

  const keysA = Object.keys(a as object);
  const keysB = Object.keys(b as object);
  if (keysA.length !== keysB.length) {
    return false;
  }

  for (const key of keysA) {
    if (!keysB.includes(key)) {
      return false;
    }
    const valA = (a as Record<string, unknown>)[key];
    const valB = (b as Record<string, unknown>)[key];
    if (!deepEqual(valA, valB)) {
      return false;
    }
  }

  return true;
}
